/**
 * 随心订日历工具：中国 2026 年法定节假日 + 周六周日标「休」，首配日规则
 */

// 2026 年中国法定节假日（放假日期均为休息日）
const HOLIDAYS_2026 = [
  '2026-01-01', '2026-01-02', '2026-01-03',
  '2026-02-15', '2026-02-16', '2026-02-17', '2026-02-18', '2026-02-19',
  '2026-02-20', '2026-02-21', '2026-02-22', '2026-02-23',
  '2026-04-04', '2026-04-05', '2026-04-06',
  '2026-05-01', '2026-05-02', '2026-05-03', '2026-05-04', '2026-05-05',
  '2026-06-19', '2026-06-20', '2026-06-21',
  '2026-09-25', '2026-09-26', '2026-09-27',
  '2026-10-01', '2026-10-02', '2026-10-03', '2026-10-04',
  '2026-10-05', '2026-10-06', '2026-10-07'
];

function formatDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function isWeekend(d) {
  const w = d.getDay();
  return w === 0 || w === 6;
}

function isHoliday(d) {
  return HOLIDAYS_2026.includes(formatDate(d));
}

/** 是否休息日：节假日或周六周日 */
function isRestDay(d) {
  return isWeekend(d) || isHoliday(d);
}

/**
 * 根据下单时间计算首个配送日
 * 规则：工作日下单次日配送；周五/周六/周日下单均为下周一起送；遇休息日顺延至最近工作日
 */
function getFirstDeliveryDate(orderDate) {
  const base = orderDate instanceof Date ? new Date(orderDate) : new Date(orderDate);
  let candidate = new Date(base.getFullYear(), base.getMonth(), base.getDate() + 1);
  const w = base.getDay();
  if (w === 5) {
    candidate = new Date(base.getFullYear(), base.getMonth(), base.getDate() + 3);
  } else if (w === 6) {
    candidate = new Date(base.getFullYear(), base.getMonth(), base.getDate() + 2);
  } else if (w === 0) {
    candidate = new Date(base.getFullYear(), base.getMonth(), base.getDate() + 1);
  }
  while (isRestDay(candidate)) {
    candidate = new Date(candidate.getFullYear(), candidate.getMonth(), candidate.getDate() + 1);
  }
  return candidate;
}

/**
 * 生成某月日历数据，休息日 label 为「休」
 */
function buildSubscriptionCalendar(year, monthIndex) {
  const days = [];
  const firstDay = new Date(year, monthIndex, 1);
  const nextMonthFirst = new Date(year, monthIndex + 1, 1);
  const totalDays = Math.round((nextMonthFirst - firstDay) / (1000 * 60 * 60 * 24));
  for (let i = 1; i <= totalDays; i++) {
    const d = new Date(year, monthIndex, i);
    const rest = isRestDay(d);
    days.push({
      date: d,
      dateStr: formatDate(d),
      day: i,
      isRest: rest,
      label: rest ? '休' : ''
    });
  }
  return days;
}

/**
 * 从起始日起连续计 n 个工作日（含起始日若为工作日），返回该段最后一个工作日。
 * 用于「周餐」等：选择起始日期后自动推算周期结束（跳过周末、节假日）。
 */
function businessDaysInclusiveEnd(startInput, businessDayCount) {
  const n = Math.max(1, Math.floor(Number(businessDayCount) || 1));
  let d = startInput instanceof Date ? new Date(startInput) : new Date(startInput);
  if (Number.isNaN(d.getTime())) return null;
  while (isRestDay(d)) {
    d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
  }
  let end = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  let left = n;
  while (left > 1) {
    end = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1);
    while (isRestDay(end)) {
      end = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1);
    }
    left -= 1;
  }
  return end;
}

export {
  HOLIDAYS_2026,
  formatDate,
  isWeekend,
  isHoliday,
  isRestDay,
  getFirstDeliveryDate,
  buildSubscriptionCalendar,
  businessDaysInclusiveEnd
};
